exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bumpers[data-v-212c6dd4] {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-md);\n}", ""]);

// exports
